//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";
import type { ToneColor } from "../types";
import { toneOf } from "./tone";

const BOX: Record<string, number> = { sm: 32, md: 40, lg: 48, xl: 56, "2xl": 64 };

export interface FeaturedIconProps extends HTMLAttributes<HTMLSpanElement> {
  children?: ReactNode;
  color?: ToneColor;
  variant?: "light" | "filled" | "outline" | "modern";
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
  radius?: "rounded" | "circle";
}

/** Tinted square/circle behind an icon — the kit's icon container. */
export function FeaturedIcon({
  children,
  color = "brand",
  variant = "light",
  size = "md",
  radius = "rounded",
  className = "",
  ...rest
}: FeaturedIconProps) {
  const t = toneOf(color);
  const px = BOX[size] ?? 40;
  const style =
    variant === "filled"
      ? { background: t.solid, color: "#fff" }
      : variant === "outline"
        ? {
            background: "var(--bg-primary)",
            color: t.solid,
            boxShadow: `inset 0 0 0 1px ${t.solid}`,
          }
        : variant === "modern"
          ? {
              background: "var(--bg-primary)",
              color: t.solid,
              boxShadow: "inset 0 0 0 1px var(--neutral-200), var(--shadow-xs)",
            }
          : { background: t.bg, color: t.solid };

  return (
    <span
      className={`bui-featured ${className}`}
      data-radius={radius}
      style={{ width: px, height: px, ...style }}
      {...rest}
    >
      {children}
    </span>
  );
}
